/**
 * Prepare webapp entry point
 *
 * @package ARS Webapp
 * @author René Schulze <schulze@thadeus-roth.de>
 */

import { createApp } from 'vue';
import App from '?/Webapp';
import router from '?/Router/Webapp';
import store from '?/Stores';
import repository from '?/Composable/Repository';
import emitter from '?/Composable/Events/Emitter';
import { i18n } from '?/Composable/Translation';

// Create app
let app = createApp(App);

// Provide global variables
app.provide('repository', repository.prepare());
app.provide('emitter', emitter);
app.provide('store', store);

// Mount app
app
    .use(router)
    .use(store)
    .use(i18n)
    .mount('#app');
